// src/components/Account/Sidebar.js
import React, { useState } from 'react';
import {
  FiHome,
  FiFileText,
  FiCreditCard,
  FiBarChart2,
  FiSettings,
  FiHelpCircle,
  FiChevronDown,
  FiChevronRight,
  FiCoffee,
  FiShoppingBag,
  FiScissors,
  FiBox,
  FiStar,
  FiGlobe,
  FiMusic,
  FiPackage,
  FiClipboard,
  FiTrendingUp,
  FiAlertCircle,
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/elegantelogo.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [openDropdowns, setOpenDropdowns] = useState({
    restaurant: false,
    beauty: false,
    spa: false,
    arcade: false,
    inventory: false,
  });

  const toggleDropdown = (key) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const menuItems = [
    { 
      name: 'dashboard', 
      label: 'Dashboard',
      icon: <FiHome />, 
      path: '/Dashboard/Accountant' 
    },
  ];

  const restaurantItems = [
    { 
      name: 'african', 
      label: 'African',
      icon: <FiCoffee />, 
      path: '/Account/AfricanTransactionDetails' 
    },
    { 
      name: 'continental', 
      label: 'Continental',
      icon: <FiGlobe />, 
      path: '/Account/ContinentalTransactionDetails' 
    },
    { 
      name: 'lounge', 
      label: 'Lounge',
      icon: <FiMusic />, 
      path: '/Account/LoungeTransactionDetails' 
    },
  ];

  const beautyItems = [
    { 
      name: 'beauty-products', 
      label: 'Products',
      icon: <FiShoppingBag />, 
      path: '#' 
    },
    { 
      name: 'beauty-services', 
      label: 'Services',
      icon: <FiShoppingBag />, 
      path: '#' 
    },
  ];

  const spaItems = [
    { 
      name: 'spa-services', 
      label: 'Services',
      icon: <FiScissors />, 
      path: '#' 
    },
    { 
      name: 'spa-packages', 
      label: 'Packages',
      icon: <FiPackage />, 
      path: '#' 
    },
  ];

  const arcadeItems = [
    { 
      name: 'arcade-games', 
      label: 'Games',
      icon: <FiBox />, 
      path: '#' 
    },
    { 
      name: 'arcade-tournaments', 
      label: 'Tournaments',
      icon: <FiStar />, 
      path: '#' 
    },
  ];

  
  const inventoryItems = [
    { 
      name: 'african-inventory', 
      label: 'African Inventory',
      icon: <FiCoffee />,  
      path: '/inventory/acc/african' 
    },
    { 
      name: 'continental-inventory', 
      label: 'Continental Inventory',
      icon: <FiGlobe />,  
      path: '/inventory/acc/continental' 
    },
    { 
      name: 'lounge-inventory', 
      label: 'Lounge Inventory',
      icon: <FiMusic />,  // Music represents Lounge
      path: '/inventory/acc/lounge' 
    },
  ];

  const otherItems = [
    { 
      name: 'payments', 
      label: 'Payments',
      icon: <FiCreditCard />, 
      path: '#' 
    },
    { 
      name: 'reports', 
      label: 'Reports',
      icon: <FiBarChart2 />, 
      path: '#' 
    },
    { 
      name: 'settings', 
      label: 'Settings',
      icon: <FiSettings />, 
      path: '#' 
    },
  ];

  const getActiveMenu = () => {
    const currentPath = location.pathname;
    
    const allItems = [
      ...menuItems, 
      ...restaurantItems, 
      ...beautyItems, 
      ...spaItems, 
      ...arcadeItems,
      ...inventoryItems,
      ...otherItems
    ];
    const activeItem = allItems.find(item => currentPath === item.path);
    return activeItem ? activeItem.name : null;
  };

  const activeMenuItem = getActiveMenu();

  const handleMenuClick = (item) => {
    navigate(item.path);
  };

  const isDropdownActive = (items) => {
    return items.some(item => activeMenuItem === item.name);
  };

  return (
    <aside className="epos-sidebar">
      <div className="epos-brand">
        <div className="brand-logo-full">
          <img src={logo} alt="Elegante Restaurant Logo" />
        </div>
      </div>

      <div className="menu-list">
        <div className="menu-section-label">📊 Accountant</div> 

        {menuItems.map((item) => (
          <button
            key={item.name}
            className={`menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
            onClick={() => handleMenuClick(item)}
          >
            <span className="menu-icon">{item.icon}</span>
            <span className="menu-text">{item.label}</span>
          </button>
        ))}

        <div className="menu-dropdown">
          <button
            className={`menu-btn dropdown-btn ${isDropdownActive(restaurantItems) ? 'active' : ''}`}
            onClick={() => toggleDropdown('restaurant')}
          >
            <span className="menu-icon"><FiCoffee /></span>
            <span className="menu-text">Restaurant / Lounge</span>
            <span className="dropdown-arrow">
              {openDropdowns.restaurant ? <FiChevronDown /> : <FiChevronRight />}
            </span>
          </button>
          {openDropdowns.restaurant && (
            <div className="dropdown-items">
              {restaurantItems.map((item) => (
                <button
                  key={item.name}
                  className={`menu-btn sub-menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-text">{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="menu-dropdown">
          <button
            className={`menu-btn dropdown-btn ${isDropdownActive(beautyItems) ? 'active' : ''}`}
            onClick={() => toggleDropdown('beauty')}
          >
            <span className="menu-icon"><FiShoppingBag /></span>
            <span className="menu-text">Beauty Store</span>
            <span className="dropdown-arrow">
              {openDropdowns.beauty ? <FiChevronDown /> : <FiChevronRight />}
            </span>
          </button>
          {openDropdowns.beauty && (
            <div className="dropdown-items">
              {beautyItems.map((item) => (
                <button
                  key={item.name}
                  className={`menu-btn sub-menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-text">{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="menu-dropdown">
          <button
            className={`menu-btn dropdown-btn ${isDropdownActive(spaItems) ? 'active' : ''}`}
            onClick={() => toggleDropdown('spa')}
          >
            <span className="menu-icon"><FiScissors /></span>
            <span className="menu-text">Spa</span>
            <span className="dropdown-arrow">
              {openDropdowns.spa ? <FiChevronDown /> : <FiChevronRight />}
            </span>
          </button>
          {openDropdowns.spa && (
            <div className="dropdown-items">
              {spaItems.map((item) => (
                <button
                  key={item.name}
                  className={`menu-btn sub-menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-text">{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="menu-dropdown">
          <button
            className={`menu-btn dropdown-btn ${isDropdownActive(arcadeItems) ? 'active' : ''}`}
            onClick={() => toggleDropdown('arcade')}
          >
            <span className="menu-icon"><FiBox /></span>
            <span className="menu-text">Arcade</span>
            <span className="dropdown-arrow">
              {openDropdowns.arcade ? <FiChevronDown /> : <FiChevronRight />}
            </span>
          </button>
          {openDropdowns.arcade && (
            <div className="dropdown-items">
              {arcadeItems.map((item) => (
                <button
                  key={item.name}
                  className={`menu-btn sub-menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-text">{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* ============================================ */}
        {/* INVENTORY DROPDOWN - NEW SECTION */}
        {/* ============================================ */}
        <div className="menu-dropdown">
          <button
            className={`menu-btn dropdown-btn ${isDropdownActive(inventoryItems) ? 'active' : ''}`}
            onClick={() => toggleDropdown('inventory')}
          >
            <span className="menu-icon"><FiClipboard /></span>
            <span className="menu-text">Inventory</span>
            <span className="dropdown-arrow">
              {openDropdowns.inventory ? <FiChevronDown /> : <FiChevronRight />}
            </span>
          </button>
          {openDropdowns.inventory && (
            <div className="dropdown-items">
              {inventoryItems.map((item) => (
                <button
                  key={item.name}
                  className={`menu-btn sub-menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-text">{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <hr className="menu-divider" />

        {otherItems.map((item) => (
          <button
            key={item.name}
            className={`menu-btn ${activeMenuItem === item.name ? 'active' : ''}`}
            onClick={() => handleMenuClick(item)}
          >
            <span className="menu-icon">{item.icon}</span>
            <span className="menu-text">{item.label}</span>
          </button>
        ))}

        <hr className="menu-divider" />

        <div className="menu-section-label" style={{ marginTop: 4 }}>
          Support
        </div>
        <button className="menu-btn" style={{ opacity: 0.7 }}>
          <span className="menu-icon">
            <FiHelpCircle />
          </span>
          <span className="menu-text">Help</span>
        </button>
      </div>

      <style>{`
        .menu-dropdown {
          width: 100%;
        }

        .dropdown-btn {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          width: 100% !important;
        }

        .dropdown-arrow {
          margin-left: auto;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #94a3b8;
          transition: transform 0.2s ease;
        }

        .dropdown-items {
          padding-left: 8px;
          margin: 2px 0;
          border-left: 2px solid rgba(198, 40, 40, 0.15);
          margin-left: 12px;
          animation: slideDown 0.3s ease;
        }

        .sub-menu-btn {
          padding-left: 20px !important;
          font-size: 0.85rem !important;
          opacity: 0.85;
        }

        .sub-menu-btn .menu-icon {
          font-size: 14px !important;
        }

        .sub-menu-btn.active {
          opacity: 1;
          background: rgba(198, 40, 40, 0.08);
          color: #C62828;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .menu-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 10px 14px;
          border: none;
          background: transparent;
          color: #475569;
          font-weight: 500;
          font-size: 0.9rem;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: left;
        }

        .menu-btn:hover {
          background: rgba(198, 40, 40, 0.05);
          color: #C62828;
        }

        .menu-btn.active {
          background: rgba(198, 40, 40, 0.08);
          color: #C62828;
          font-weight: 600;
        }

        .menu-btn.active .menu-icon {
          color: #C62828;
        }

        .menu-icon {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #94a3b8;
          min-width: 24px;
        }

        .menu-text {
          flex: 1;
        }

        .menu-section-label {
          font-size: 0.7rem;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding: 8px 14px 4px;
          margin-top: 8px;
        }

        .menu-divider {
          border: none;
          border-top: 1px solid rgba(0, 0, 0, 0.06);
          margin: 8px 14px;
        }

        .epos-sidebar {
          width: 260px;
          background: #ffffff;
          border-right: 1px solid rgba(0, 0, 0, 0.06);
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }

        .epos-brand {
          padding: 16px 20px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        }

        .brand-logo-full img {
          width: 100%;
          max-width: 160px;
          height: auto;
          display: block;
        }

        .menu-list {
          flex: 1;
          padding: 8px 12px;
          overflow-y: auto;
        }

        .epos-sidebar::-webkit-scrollbar {
          width: 4px;
        }

        .epos-sidebar::-webkit-scrollbar-track {
          background: transparent;
        }

        .epos-sidebar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }

        .epos-sidebar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;